import React, { useEffect,useState } from "react";
import { useMediaQuery } from "react-responsive";
import { FaArrowCircleUp,FaArrowCircleDown } from "react-icons/fa";
import AOS from "aos"
import Header from "../Header"
import {Helmet} from "react-helmet"
import {Link} from "react-router-dom"
import {motion} from "framer-motion"
import Footer from "../Footer"
import Navbar from "../Navbar";
import NavbarInOtherPage from "../NavbarInOtherPage"
import "./index.css"
import DetailsForm from "../DetailsForm";

const PhpDevelopment=()=>{
    const [phpfaq1,setFqaphp1]=useState(false)
    const [phpfaq2,setFqaphp2]=useState(false)
    const [phpfaq3,setFqaphp3]=useState(false)
    const [phpfaq4,setFqaphp4]=useState(false)
    useEffect(() => {
        AOS.init({
          
          duration : 2000
        });
      }, []);
    
      const mediaQueryCondition=useMediaQuery({ query: '(max-width:1024px)' })
    return(
        <>
        <Helmet>
        <title>Elevate Your Online Presence with Insu Creation's PHP Web Development Expertise</title>
<meta name="description" content="Discover the power of PHP web development with Insu Creation. Our expert team crafts custom solutions tailored to your business needs, ensuring efficient, secure, and scalable web applications. Partner with us to elevate your online presence and drive success."/>
<meta name="keywords" content="Insu Creation, SEO, digital solutions, web development, marketing strategies, branding, SEO, social media marketing, e-commerce, content creation, online presence, business growth, digital innovation, customer engagement, website optimization, digital transformation, digital agency, online marketing, digital strategy, digital consultancy, digital services, digital expertise" />

        </Helmet>
         <Header />
    {mediaQueryCondition?<Navbar />:<NavbarInOtherPage />}
    <DetailsForm />
    <div className="partner-with-us-route-main-con">
      <div className="partner-with-us-route-main-con-1">
        <div className="partner-route-con">
          <h1 className="partner-route-about-head" data-aos="fade-right">PHP Development: Harnessing the Backbone of the Web</h1>
          <p data-aos="fade-left">PHP serves as the backbone of the internet, underpinning numerous renowned websites worldwide. Our team specializes in PHP development, utilizing its universal compatibility and robust framework to create dynamic and interactive web solutions.</p>
          <p data-aos="fade-left">From enterprise websites requiring dynamic user input to complex e-commerce stores with extensive product catalogs, we cater to diverse needs.</p>
          <p data-aos="fade-left"> With a wealth of experience working with companies of all sizes and industries, we deliver affordable and reliable PHP solutions tailored to your specific requirements.</p>

          <p data-aos="fade-left">Partner with us to transform your concepts into scalable and functional web applications, leveraging the power of PHP development.</p>

          <Link to="schedule-meeting"><button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Request a Demo<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
    </button></Link>
        </div>
        <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712240945/jd81lrosjkuhamim9toc.png" data-aos="zoom-in" alt="" className="about-partner-img" />
      </div>
    </div>
    <div className="partner-with-us-route-main-con">
      <div className="partner-with-us-route-main-con-1">
        <div className="partner-route-con partner-route-con-2">
          <h1 className="partner-route-about-head partner-route-about-head-2">Benefits of PHP Development</h1>
          <ul className="transform-right-list-container">
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">Access to Thousands of Open Source Libraries: PHP offers a vast array of open-source libraries, enhancing development efficiency and versatility.
Compatibility with All Hosting Environments: PHP is compatible with various hosting environments, ensuring seamless deployment and integration.
</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">Ideal for Responsive Web Pages: With its robust features, PHP is well-suited for creating responsive web pages that adapt to different devices and screen sizes.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">Direct Integration with HTML and CSS: PHP allows for direct integration with HTML and CSS, streamlining the development process and reducing complexity.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">No Need for Additional Plugins: PHP eliminates the need for additional plugins when creating web pages on platforms like WordPress and Drupal, enhancing efficiency and simplicity.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="ransform-right-2-para">Optimal for E-Commerce Development: PHP's fast loading and response times make it perfect for developing E-commerce websites with numerous pages and high traffic volumes.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="ransform-right-2-para">Built-In HTTP Server: PHP includes a built-in HTTP server, facilitating easy development and testing of applications locally without the need for configuring external servers.</p>
        </div>
      </li>
     
    </ul>
        
        </div>
        <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712241016/z5rs0szjujpgqr7becou.png" data-aos="zoom-in" alt="" className="about-partner-img about-partner-img-2" />
      </div>
    </div>
    <div className="php-development-route-p-con">
        <h1 className="php-developer-rote-head php-developer-rote-head-r-r">What we offer with PHP development?</h1>
        <p className="php-developer-rote-para">We provide innovative web application development services with PHP development environment through an array of services.</p>
        <div className="php-development-route-p-con-1 php-development-route-p-con-1-res-n">
            <div className="php-development-route-p-con-1-inner">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712241577/yr5tmmya4lo4yeneat3n.png" className="php-development-route-p-con-img" alt="" />
                <h1 className="heading-phpcustom-app">Custom PHP Applications</h1>
                <p className="para-phpcustom-app">Utilizing our extensive expertise in Object-Oriented Programming (OOP), Model-View-Controller (MVC), and core PHP, we develop and deploy static, dynamic, and integrated PHP web applications. Our PHP development firm leverages leading PHP frameworks such as CodeIgniter, CakePHP, Laravel, Zend, Yii, Symfony, etc., to craft enterprise-grade applications.</p>
            </div>
            <div className="php-development-route-p-con-1-inner">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320163/polpefnscwqwbhdtiadp.png" className="php-development-route-p-con-img" alt="" />
                <h1 className="heading-phpcustom-app">E-Commerce Solutions</h1>
                <p className="para-phpcustom-app">We excel in employing the right mix of technologies to craft top-tier eCommerce PHP websites with modern features and functionalities. Our PHP development team is adept at building highly customized eCommerce portals tailored to your specific requirements.</p>
            </div>
            <div className="php-development-route-p-con-1-inner">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320218/crqu1h6umkvnwy06tdko.png" className="php-development-route-p-con-img" alt="" />
                <h1 className="heading-phpcustom-app">CMS Development</h1>
                <p className="para-phpcustom-app">With profound proficiency in open-source CMS platforms like WordPress, Drupal, Joomla, Magento, etc., our PHP web development company creates bespoke websites leveraging these CMSs. Our developers harness the full potential of CMSs to deliver tailored solutions.</p>
            </div>
            <div className="php-development-route-p-con-1-inner">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320258/qzgqz2nrorvnkhoqfbo7.png" className="php-development-route-p-con-img" alt="" />
                <h1 className="heading-phpcustom-app">Social Networking Platforms</h1>
                <p className="para-phpcustom-app">Leveraging the latest features of PHP, we craft engaging, visually appealing, and collaborative social networking websites. Our developers seamlessly integrate cutting-edge features into these platforms for enhanced user experiences.</p>
            </div>
            <div className="php-development-route-p-con-1-inner">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320300/bxwpj7gghjkvxiarcscb.png" className="php-development-route-p-con-img" alt="" />
                <h1 className="heading-phpcustom-app">API Integration</h1>
                <p className="para-phpcustom-app">We seamlessly integrate public, private, or internal APIs into your PHP system and CMS. Additionally, we integrate third-party APIs into your PHP websites as per your requirements, using various interfaces provided by the APIs for enhanced transactions.</p>
            </div>
            <div className="php-development-route-p-con-1-inner">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320340/s1krhcyxbnlgtliltpau.png" className="php-development-route-p-con-img" alt="" />
                <h1 className="heading-phpcustom-app">Custom Web Portals</h1>
                <p className="para-phpcustom-app">Our seasoned developers specialize in crafting business-specific web portals using PHP, including B2C portals, B2B portals, enterprise portals, and company portals. As a trusted PHP website development company, we prioritize client satisfaction and deliver reliable solutions.</p>
            </div>
        </div>
    </div>
    <div className="php-development-route-p-con">
    <h1 className="php-developer-rote-head php-developer-rote-head-r-r">Our Process</h1>
    <p className="php-developer-rote-head-follow">At insu creation, we adhere to a meticulous process to fulfill your requirements and deliver optimal outcomes.</p>
    <div className="php-development-route-p-con-1">
        <div className="php-development-dd-con">
            <div className="image-php-rote-develop">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712242350/twcip1l5akj55uxeoly6.png" className="image-php-rote-develop-img" alt="" />
            </div>
            <div>
                <h1 className="requirement-gath-heading">Requirement Gathering</h1>
                <p className="requirement-gath-para">We commence with brainstorming sessions and meetings to ensure alignment between both parties through a comprehensive Statement of Work.</p>
            </div>
        </div>
        <div className="php-development-dd-con">
            <div className="image-php-rote-develop">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712243991/k1xktnuhlfqp1v2anenz.png" className="image-php-rote-develop-img" alt="" />
            </div>
            <div>
                <h1 className="requirement-gath-heading">UX/ UI</h1>
                <p className="requirement-gath-para"><span className="requirement-gath-para-span">PROTOTYPE</span> - We craft a fully functional clickable prototype, employing diverse wireframes and mock-ups, subject to client approval.</p>
            </div>
        </div>
        <div className="php-development-dd-con">
            <div className="image-php-rote-develop">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712244030/tl2mbbjikv9c7xs0b6cd.png" className="image-php-rote-develop-img" alt="" />
            </div>
            <div>
                <h1 className="requirement-gath-heading">Development</h1>
                <p className="requirement-gath-para"><span className="requirement-gath-para-span">WORKING APPLICATION</span> - We embark on system architecture, database planning, infrastructure setup, and code development to create a working application.</p>
            </div>
        </div>
        <div className="php-development-dd-con">
            <div className="image-php-rote-develop">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712244072/xh3zohkhr5s4cp8a06mm.png" className="image-php-rote-develop-img" alt="" />
            </div>
            <div>
                <h1 className="requirement-gath-heading">Deployment</h1>
                <p className="requirement-gath-para"><span className="requirement-gath-para-span">FINAL PRODUCT</span> - The final product undergoes client server setup, followed by seamless transfer and deployment of the PHP application project in a live environment.</p>
            </div>
        </div>
        <div className="php-development-dd-con">
            <div className="image-php-rote-develop">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712244124/itiaaiwoaufinr2nlquf.png" className="image-php-rote-develop-img" alt="" />
            </div>
            <div>
                <h1 className="requirement-gath-heading">Testing</h1>
                <p className="requirement-gath-para">Our rigorous quality assurance process includes manual and system testing, with regular client feedback incorporated as part of our agile methodology.</p>
            </div>
        </div>
        <div className="php-development-dd-con">
            <div className="image-php-rote-develop">
                <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712244160/em9lxp9sz4swgglpwlik.png" className="image-php-rote-develop-img" alt="" />
            </div>
            <div>
                <h1 className="requirement-gath-heading">Delivery</h1>
                <p className="requirement-gath-para">Upon completion, we inform the client that the project is live and ready for use.
Benefits of PHP Framework Based Development</p>
            </div>
        </div>
    </div>
    </div>
    <div className="partner-with-us-route-main-con partner-with-us-route-main-con-pty">
    <h1 className="partner-insu-head-c partner-insu-head-c-reed">PHP Framework Based Development</h1>
    <p className="para-parner-types-p">We provide Development in the PHP Frameworks as well.</p>
    <div className="container-route-partners">
      <div className="container-route-partners-item container-php-partn-it" data-aos="fade-up">
        <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1711982467/oqqau8hdn4kbmzstumha.png" className="image-route-partner" alt="" />
        <h1 className="larvel-head-part">Laravel</h1>
        <p className="para-parner-types-p para-parner-types-p-2">Laravel is a free, open-source PHP web framework, created by Taylor Otwell and intended for the development of web applications following the model–view–controller architectural pattern and based on Symfony. </p>

      </div>
      <div className="container-route-partners-item container-php-partn-it" data-aos="fade-up">
        <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320388/gt1m2foh5ozev767njra.png" className="image-route-partner" alt="" />
        <h1 className="larvel-head-part">CodeIgniter</h1>
        <p className="para-parner-types-p para-parner-types-p-2">CodeIgniter is an open-source software rapid development web framework, for use in building dynamic web sites . It is loosely based on the popular model–view–controller  development pattern.</p>

      </div>
      <div className="container-route-partners-item container-php-partn-it" data-aos="fade-up">
        <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320429/jc5amdfevgrm9ilfl1ya.png" className="image-route-partner" alt="" />
        <h1 className="larvel-head-part">CakePHP</h1>
        <p className="para-parner-types-p para-parner-types-p-2">CakePHP is an open-source web framework. CakePHP follows the model–view–controller (MVC) approach and is written in PHP, modelled after the concepts of Ruby on Rails, and distributed under the MIT License.</p>

      </div>
      <div className="container-route-partners-item container-php-partn-it" data-aos="fade-up">
        <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320462/tscdtz5guhayulngvhjc.png" className="image-route-partner" alt="" />
        <h1 className="larvel-head-part">Drupal</h1>
        <p className="para-parner-types-p para-parner-types-p-2">Drupal is a free and open-source web content management framework written in PHP and distributed under the GNU General Public License. Drupal provides a back-end framework for at least 2.3% of all websites worldwide. </p>

      </div>
    </div>
    </div>
    <div className="partner-with-us-route-main-con">
      <div className="partner-with-us-route-main-con-1">
        <div className="partner-route-con partner-route-con-2">
          <h1 className="partner-route-about-head partner-route-about-head-2">Benefits of PHP Framework Based Development</h1>
          <ul className="transform-right-list-container un-order-list-items-php">
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">Eliminates the need for writing additional code.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">Facilitates efficient unit testing processes.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">Simplifies the maintenance of web applications.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="transform-right-2-para">Enhances efficiency in working with databases.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="ransform-right-2-para">Automates common web development tasks.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="ransform-right-2-para">Maintains affordability without increasing development costs.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="ransform-right-2-para">Accelerates custom web application development.</p>
        </div>
      </li>
      <li className="transform-right-list-container-items-2">
        <div className="list-transform list-transform-brand">
        <img
            src="https://img.freepik.com/free-icon/check_318-749749.jpg"
            className="right-check"
            alt="right-check"
          />
          <p className="ransform-right-2-para">Bolsters website security, safeguarding against targeted attacks.</p>
        </div>
      </li>
    
    </ul>
        
        </div>
        <img src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712410342/eyakkdt9fenpkp66ycwl.png" data-aos="zoom-in" alt="" className="about-partner-img about-partner-img-2" />
      </div>
    </div>


    <div className="why-choose-us-container">
    <h3 class="head-ani-gradient head-ani-gradient-pt head-ani-gradient-pt-cus">WE DELIVER OUR BEST</h3>

    <p className="why-we-deliver why-we-deliver-mob-view">Why Choose Insu Creation?</p>
    <p className="paragh-php">We are the best at what we do.</p>
    <ul className="why-choose-us-list-container why-choose-us-list-container-mob-view why-choose-us-list-container-mob-view-ul-l">
      <motion.li whileHover={{scale:1.09}} data-aos="fade-right" className="services-container services-container-mob-view php-why-choose-us-con">
        <img
          src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320534/h7bp53ngc43gn5h3rqsz.png"
          className="services-img services-img-partne"
          alt="services-img"
        />
        <div>
          <h1 className="services-heading">Expertise</h1>
          <p className="services-paragraph">
          We expertise in the PHP Development.
          </p>
        </div>
      </motion.li>
      <motion.li whileHover={{scale:1.09}} data-aos="fade-right" className="services-container services-container-mob-view php-why-choose-us-con">
        <img
          src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320625/n7inhbdgptywwyevz5xa.png"
          className="services-img services-img-partne"
          alt="services-img"
        />
        <div>
          <h1 className="services-heading">Secure</h1>
          <p className="services-paragraph">
          Your data and security is our focus.
          </p>
        </div>
      </motion.li>
      <motion.li whileHover={{scale:1.09}} data-aos="fade-right" className="services-container services-container-mob-view php-why-choose-us-con">
        <img
          src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1711984745/wdgwmhubpahsumtsczru.png"
          className="services-img services-img-partne"
          alt="services-img"
        />
        <div>
          <h1 className="services-heading">Expert Teams</h1>
          <p className="services-paragraph">
          We house a team of Expert Developers.
          </p>
        </div>
      </motion.li>
      <motion.li whileHover={{scale:1.09}} data-aos="fade-right" className="services-container services-container-mob-view php-why-choose-us-con">
        <img
          src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320661/slay4khnuyhec3f9rnpa.png"
          className="services-img services-img-partne"
          alt="services-img"
        />
        <div>
          <h1 className="services-heading">Customer Satisfaction</h1>
          <p className="services-paragraph">
          Our prime focus is your satisfaction with our services.
          </p>
        </div>
      </motion.li>
      <motion.li whileHover={{scale:1.09}} data-aos="fade-right" className="services-container services-container-mob-view php-why-choose-us-con">
        <img
          src="https://res.cloudinary.com/dlj7gj1po/image/upload/v1712320707/zg6vhzb0vxgx3q24sgv4.png"
          className="services-img services-img-partne"
          alt="services-img"
        />
        <div>
          <h1 className="services-heading">Punctuality</h1>
          <p className="services-paragraph">
          We know the importance of time in a business.
          </p>
        </div>
      </motion.li>
    
     
    </ul>
    <div className="want-enquire-new-btn">
      <p className="want-enquire-new-btn-para new-insu-btn-want-makes">Want to <span className="want-enquire-new-btn-span">Start</span> a New Project</p>
  
      <Link to="/contactus"><button type="button" className="new-want-btn new-want-btn-1">Enquire Now</button></Link>
    </div>
  </div>
  <div className="php-development-route-p-con">
  <h1 className="partner-insu-head-c partner-insu-head-c-faq">Frequently Asked Questions</h1>

    <div className="php-development-route-p-con-1-div">
        <div className="faq-question-php-route-con-main">
            <div className="faq-question-php-route-con" onClick={()=>setFqaphp1(!phpfaq1)}>
                <h1 className="faq-question-php-route">How much time do you require to complete a PHP web application?</h1>
               {phpfaq1?<FaArrowCircleDown className="fa-arrow-circle-up"  />: <FaArrowCircleUp className="fa-arrow-circle-up" />}
            </div>
            {phpfaq1 &&
            <div>
                <p className="faq-question-php-route-ans">We prioritize transparency and honesty in our approach. To provide an accurate time estimate for your project, we need to discuss its details and requirements thoroughly. Our experts will then share a realistic timeline based on the scope and complexity of the project.</p>
            </div>}
        </div>
        <div className="faq-question-php-route-con-main">
            <div className="faq-question-php-route-con" onClick={()=>setFqaphp2(!phpfaq2)}>
                <h1 className="faq-question-php-route">Will you assist in modifying the website design in the future?</h1>
               {phpfaq2?<FaArrowCircleDown className="fa-arrow-circle-up"  />: <FaArrowCircleUp className="fa-arrow-circle-up" />}
            </div>
            {phpfaq2 &&
            <div>
                <p className="faq-question-php-route-ans">Yes, our developers are available to make necessary changes to your website design as per your requirements. Whether it's adjusting the content, layout, or appearance, we're here to help. We recommend defining the project's scope and important elements upfront to ensure tailored web solutions aligned with your needs.</p>
            </div>}
        </div>
        <div className="faq-question-php-route-con-main">
            <div className="faq-question-php-route-con" onClick={()=>setFqaphp3(!phpfaq3)}>
                <h1 className="faq-question-php-route">How much time do you require to complete a PHP web application?</h1>
               {phpfaq3?<FaArrowCircleDown className="fa-arrow-circle-up"  />: <FaArrowCircleUp className="fa-arrow-circle-up" />}
            </div>
            {phpfaq3 &&
            <div>
                <p className="faq-question-php-route-ans">Yes, we will help you modify your website design in the future. Our developers can make the required changes in the site content, layout, and appearance based on your needs. We recommend discussing and defining all the project's important elements and its scope before getting started. We create tailored web solutions as per the needs and requirements of our clients.</p>
            </div>}
        </div>
        <div className="faq-question-php-route-con-main">
            <div className="faq-question-php-route-con" onClick={()=>setFqaphp4(!phpfaq4)}>
                <h1 className="faq-question-php-route">Can you assist in integrating third-party services into the PHP web application?</h1>
               {phpfaq4?<FaArrowCircleDown className="fa-arrow-circle-up"  />: <FaArrowCircleUp className="fa-arrow-circle-up" />}
            </div>
            {phpfaq4 &&
            <div>
                <p className="faq-question-php-route-ans">Yes, we have experience in integrating various third-party services and APIs into PHP web applications. Whether it's payment gateways, social media platforms, or other external services, our developers can seamlessly integrate them into your application to enhance its functionality and user experience. Let's discuss your specific requirements to find the best integration solutions for your project.</p>
            </div>}
        </div>
    </div>
   <Link to="/contactus"> <button type="button" className="our-technologies-stack-btn"><p class="btn-main btn-main-m bg-btn2 lnk bg-btn2-m">Ask a Question<i class="fas fa-chevron-right fa-icon"></i><span class="circle"></span></p>
    </button></Link>
  </div>
  <Footer />
        </>
    )
}

export default PhpDevelopment